export default __webpack_public_path__ + "logo-appstore-0d868f6b93eb93c449af23d545146c34.svg";